// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select_selectContainer__-1-dd {
  box-sizing: border-box;
  display: grid;
  grid-template-areas: 'select';
  align-items: center;

  width: 100%;
  height: 44px;
  background-color: transparent;
  border: 1px solid var(--borderColor);
  border-radius: 3px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  line-height: 17.07px;
  text-align: left;
  color: var(--textColor);
  outline: 1px solid transparent;
  transition-property: border-color, background-color, outline-color;
  transition-duration: 0.2s;
  transition-timing-function: ease-in-out;
}
.select_selectContainer__-1-dd .select_selectChevron__Ag4gW {
    justify-self: end;
    margin-right: 16px;
    transform: rotate(90deg);
    pointer-events: none;
  }
.select_selectContainer__-1-dd .select_selectDropdown__kL6Hc {
    box-sizing: border-box;
    appearance: none;
    background-color: transparent;
    border: none;
    padding: 0px 32px 0 16px;
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    cursor: inherit;
    line-height: inherit;
    outline: none;

    width: 100%;
    height: 100%;
    color: var(--textColor);
  }
.select_selectContainer__-1-dd .select_selectChevron__Ag4gW,
  .select_selectContainer__-1-dd .select_selectDropdown__kL6Hc {
    grid-area: select;
  }
.select_selectContainer__-1-dd:hover {
    background-color: var(--hoverBackground);
  }
.select_selectContainer__-1-dd:focus-within {
    border-color: var(--primaryColor);
    outline-color: var(--primaryColor);
  }
`, "",{"version":3,"sources":["webpack://./src/components/select/select.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;;EAEnB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,kEAAkE;EAClE,yBAAyB;EACzB,uCAAuC;AAsCzC;AApCE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,wBAAwB;IACxB,oBAAoB;EACtB;AACA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,6BAA6B;IAC7B,YAAY;IACZ,wBAAwB;IACxB,SAAS;IACT,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,oBAAoB;IACpB,aAAa;;IAEb,WAAW;IACX,YAAY;IACZ,uBAAuB;EACzB;AACA;;IAEE,iBAAiB;EACnB;AAEA;IACE,wCAAwC;EAC1C;AACA;IACE,iCAAiC;IACjC,kCAAkC;EACpC","sourcesContent":[".selectContainer {\n  box-sizing: border-box;\n  display: grid;\n  grid-template-areas: 'select';\n  align-items: center;\n\n  width: 100%;\n  height: 44px;\n  background-color: transparent;\n  border: 1px solid var(--borderColor);\n  border-radius: 3px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 17.07px;\n  text-align: left;\n  color: var(--textColor);\n  outline: 1px solid transparent;\n  transition-property: border-color, background-color, outline-color;\n  transition-duration: 0.2s;\n  transition-timing-function: ease-in-out;\n\n  & .selectChevron {\n    justify-self: end;\n    margin-right: 16px;\n    transform: rotate(90deg);\n    pointer-events: none;\n  }\n  & .selectDropdown {\n    box-sizing: border-box;\n    appearance: none;\n    background-color: transparent;\n    border: none;\n    padding: 0px 32px 0 16px;\n    margin: 0;\n    font-family: inherit;\n    font-size: inherit;\n    font-weight: inherit;\n    cursor: inherit;\n    line-height: inherit;\n    outline: none;\n\n    width: 100%;\n    height: 100%;\n    color: var(--textColor);\n  }\n  & .selectChevron,\n  & .selectDropdown {\n    grid-area: select;\n  }\n\n  &:hover {\n    background-color: var(--hoverBackground);\n  }\n  &:focus-within {\n    border-color: var(--primaryColor);\n    outline-color: var(--primaryColor);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectContainer": `select_selectContainer__-1-dd`,
	"selectChevron": `select_selectChevron__Ag4gW`,
	"selectDropdown": `select_selectDropdown__kL6Hc`
};
export default ___CSS_LOADER_EXPORT___;
